const router = [
  {
    path: 'detail/:id',
    name: 'document-detail',
    component: () => import('@/modules/Documents/detail/pages/index.vue'),
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      action: 309
    },
  }
]

export default router